exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n/* Fix for checkboxes label */\n.custom-control-label[data-v-33a2c663] {\r\n  padding-top: 2px;\n}\n.tree-menu-item[data-v-33a2c663] {\r\n  padding: 0.2em 1em;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-33a2c663","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/CheckableTreeViewItem.vue
// module id = fBlG
// module chunks = 70